var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChromeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4050_3719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3574 33.1073L26.9778 14.7132L28.9502 14.747L32.1741 14.8712L42.9433 18.5991L51.0123 14.7132C46.5468 5.97922 37.4606 0 26.9778 0C17.4556 0 9.08613 4.93396 4.28516 12.3845V12.4026L5.10142 26.2109L16.3574 33.1073Z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3566 33.1071L4.2844 12.4024L4.27882 12.3928C1.57131 16.598 0 21.6038 0 26.9769C0 41.4475 11.3936 53.2557 25.6991 53.9231L35.3397 47.5295L37.5955 33.1107L16.3566 33.1071Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0116 14.7131H26.9772L37.5976 33.1073L37.5956 33.1109L25.6992 53.9233C25.7024 53.9234 25.7054 53.9235 25.7086 53.9236C26.1292 53.9431 26.5518 53.9541 26.9773 53.9541C41.8763 53.9541 53.9543 41.8761 53.9543 26.9771C53.9542 22.5608 52.8929 18.3926 51.0116 14.7131Z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9768 39.241C33.75 39.241 39.2407 33.7502 39.2407 26.9771C39.2407 20.2039 33.75 14.7131 26.9768 14.7131C20.2036 14.7131 14.7129 20.2039 14.7129 26.9771C14.7129 33.7502 20.2036 39.241 26.9768 39.241Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9771 36.788C32.3957 36.788 36.7883 32.3954 36.7883 26.9769C36.7883 21.5584 32.3957 17.1658 26.9771 17.1658C21.5586 17.1658 17.166 21.5584 17.166 26.9769C17.166 32.3954 21.5586 36.788 26.9771 36.788Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4050_3719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.9542,
    height: 53.9542,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeIcon);
export default __webpack_public_path__ + "static/media/chrome_icon.1e532dc480bd8a9e42150408f4a35366.svg";
export { ForwardRef as ReactComponent };